import React from 'react';

import cx from 'classnames';

import { useNavigationCommands } from '../../commands/CustomizationCommandsContext';
import type { RailEntryViewModel } from '../../viewmodels/createSectionsRailViewModel';

import styles from './SectionsRail.scss';

type Props = {
  viewModel: RailEntryViewModel;
};

export function SectionsRailEntry({ viewModel }: Props) {
  const { selectSection } = useNavigationCommands();
  const handleClick = () => {
    selectSection(viewModel.id);
  };

  return (
    <li>
      <button
        type="button"
        className={cx(
          styles.entry,
          viewModel.isActive && styles.active,
          viewModel.isHidden && styles.hidden
        )}
        aria-current={viewModel.isActive || undefined}
        title={viewModel.name}
        data-test="section-rail-entry"
        onClick={handleClick}
      >
        {viewModel.name}
      </button>
    </li>
  );
}
